export default {"src":"/_next/static/image/public/images/ic_patient_portal.2f815dc630b8bb6c399972f9771d8d2e.svg","height":203,"width":190};